import { createAction, props } from '@ngrx/store';
export const setPageErrorMessage = createAction('[Page Error Message] Set Page Error Message', props());
export const clearPageErrorMessage = createAction('[Page Error Message] Clear Page Error Message');
export const removePageErrorMessages = createAction('[Page Error Message] Remove Page Error Messages', props());
